import { defaultWalletSettings } from '../../data-types/wallet/walletConstants';
import {
  CustomizationActionType,
  CustomizationState,
  SET_ALL_AVAILABLE_COUNTRY_SETTINGS,
  SET_BET_PLACEMENT_ROCKET_ANIMATION,
  SET_BETKWIFF_DOMAIN_FLAG,
  SET_CAN_PLAY_CASINO,
  SET_CAN_SHOW_AVIATOR,
  SET_CASINO_FIRST_FLAG,
  SET_COUNTRY_SETTINGS_BY_LOCATION,
  SET_FEATURE_FLAGS,
  SET_MAINTENANCE,
  SET_MOODBAR_SCORE,
  SET_NET_PROMOTER_SCORE_FLAG,
  SET_REORDER_CASINO_FILTERS,
  SET_WALLET_SETTINGS,
} from '../types/customizationTypes';
import { RESET_STATE } from '../types/stateTypes';

export const initialCustomizationState: CustomizationState = {
  featureFlags: {
    cashout: false,
    moodBar: false,
    trendingBets: false,
    feedbackForum: false,
    casinoNetAndTimer: false,
    betkwiffDomain: false,
    displayBespokeRecommendedGames: false,
    bespokeSportsMenu: false,
    bespokeCompetitions: false,
    referAFriend: false,
    promoCentre: false,
  },
  moodBarScore: 0,
  isCasinoFirst: false,
  maintenance: false,
  internationalSettings: {
    walletSettings: defaultWalletSettings,
    countrySettingsByLocation: undefined,
    allAvailableCountrySettings: [],
    permissions: {
      canPlayCasino: false,
      canShowAviator: false,
    },
  },
  netPromoterScoreFlag: false,
  reorderCasinoFilters: false,
  betPlacementRocketAnimation: false,
};

export const customizationReducer = (state = initialCustomizationState, action: CustomizationActionType): CustomizationState => {
  switch (action.type) {
    case RESET_STATE:
      return {
        ...initialCustomizationState,
      };
    case SET_CASINO_FIRST_FLAG: {
      return { ...state, isCasinoFirst: action.meta };
    }
    case SET_FEATURE_FLAGS: {
      return {
        ...state,
        featureFlags: { ...state.featureFlags, ...action.meta },
      };
    }

    case SET_MOODBAR_SCORE: {
      return { ...state, moodBarScore: action.meta };
    }

    case SET_MAINTENANCE: {
      return { ...state, maintenance: action.meta };
    }

    case SET_BETKWIFF_DOMAIN_FLAG: {
      return { ...state, featureFlags: { ...state.featureFlags, betkwiffDomain: action.meta } };
    }

    case SET_WALLET_SETTINGS: {
      return { ...state, internationalSettings: { ...state.internationalSettings, walletSettings: action.meta } };
    }

    case SET_ALL_AVAILABLE_COUNTRY_SETTINGS: {
      return {
        ...state,
        internationalSettings: { ...state.internationalSettings, allAvailableCountrySettings: action.meta },
      };
    }

    case SET_COUNTRY_SETTINGS_BY_LOCATION: {
      return {
        ...state,
        internationalSettings: { ...state.internationalSettings, countrySettingsByLocation: action.meta },
      };
    }

    case SET_CAN_PLAY_CASINO: {
      return {
        ...state,
        internationalSettings: {
          ...state.internationalSettings,
          permissions: {
            ...state.internationalSettings.permissions,
            canPlayCasino: action.meta,
          },
        },
      };
    }

    case SET_NET_PROMOTER_SCORE_FLAG: {
      return { ...state, netPromoterScoreFlag: action.meta };
    }

    case SET_REORDER_CASINO_FILTERS: {
      return { ...state, reorderCasinoFilters: action.meta };
    }

    case SET_CAN_SHOW_AVIATOR: {
      return {
        ...state,
        internationalSettings: {
          ...state.internationalSettings,
          permissions: {
            ...state.internationalSettings.permissions,
            canShowAviator: action.meta,
          },
        },
      };
    }

    case SET_BET_PLACEMENT_ROCKET_ANIMATION: {
      return { ...state, betPlacementRocketAnimation: action.meta };
    }
    default:
      return state;
  }
};
